<div class="multi-select-dropdown" [class.disabled]="disabled">
  <div 
    class="form-control dropdown-toggle d-flex align-items-center flex-wrap"
    (click)="toggleDropdown()"
    [class.show]="isOpen"
    [attr.aria-expanded]="isOpen"
    aria-haspopup="listbox"
    tabindex="0"
    style="max-height: 37.45px; padding: 3px 12px;"
  >
    @if (selectedItems.length === 0) {
      <span class="placeholder" style="cursor: pointer !important; background-color: transparent !important;">{{ placeholder }}</span>
    }
    @for (itemId of selectedItems; track itemId) {
      @if (chipTemplate) {
        <ng-container 
          *ngTemplateOutlet="chipTemplate; context: { $implicit: getItemById(itemId) }"
        />
      } @else {
        <span class="badge bg-primary me-1 mb-1 d-flex align-items-center">
          {{ getItemById(itemId)?.text }}
          <button 
            type="button" 
            class="btn-close ms-1" style="color: #146c43;" 
            aria-label="Remove"
            (click)="removeSelectedItem(itemId, $event)"
          ></button>
        </span>
      }
    }
  </div>

  @if (isOpen) {
    <div 
      @dropdownAnimation
      class="dropdown-menu w-100 show"
      [class.show]="isOpen"
      #dropdownMenu
    >
      @if (showSearch) {
        <div class="px-3 py-2 border-bottom">
          <input
            type="text"
            class="form-control form-control-sm"
            placeholder="Search..."
            [(ngModel)]="searchQuery"
            #searchInput
            (click)="$event.stopPropagation()"
          />
        </div>
      }
      
      <div class="dropdown-list">
        <button
        *ngIf="showSelectAll"
          type="button"
          class="dropdown-item"
          (click)="toggleSelectAll()"
        >
          <div class="form-check" >
            <input
              class="form-check-input checkbox"
              type="checkbox"
              
              [checked]="selectedItems.length === filteredItems.length && filteredItems.length > 0"
              [indeterminate]="selectedItems.length > 0 && selectedItems.length < filteredItems.length"
              (click)="toggleSelectAll(); $event.stopPropagation()"
            >
            <label class="form-check-label w-100">
              {{ selectAllText }}
            </label>
          </div>
        </button>
        
        <div *ngIf="showSelectAll" class="dropdown-divider"></div>
        
        @for (item of filteredItems; track item.id; let i = $index) {
          <button
            type="button"
            class="dropdown-item"
            [class.active]="focusedItemIndex === i"
            (click)="toggleItemSelection(item.id)"
          >
            @if (itemTemplate) {
              <ng-container 
                *ngTemplateOutlet="itemTemplate; context: { $implicit: item, selected: isSelected(item.id) }"
              />
            } @else {
              <div class="form-check">
                <input
                  class="form-check-input checkbox"
                  type="checkbox"
                  [checked]="isSelected(item.id)"
                  (click)="toggleItemSelection(item.id); $event.stopPropagation()"
                  readonly
                >
                <label class="form-check-label w-100">
                  {{ item.text }}
                </label>
              </div>
            }
          </button>
        }
        
        @if (filteredItems.length === 0) {
          <div class="dropdown-item text-muted">No items found</div>
        }
      </div>
    </div>
  }
</div>